import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as variablesBuilder from '../../../../../../variables-builder'
import * as componentStore from '../../component-store'

import * as generalTab from './general-tab'
import * as queryTab from './query-tab'
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    generalTab.Component,
    queryTab.Component,
    variablesBuilder.Component,
  ],
  selector: 'atn-mosaic-page-configuration-dialog',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** @see {@link Store} */
  public readonly store = ngCore.inject(componentStore.configuration.Store)

  /** Save changes handler */
  public saveClickHandler(): void {
    // Closing page configuration dialog
    this.store.patchState({ presentPageConfiguration: false })

    // Dispatches an edit action to update the page editing state with page
    // configuration changes
    this.pagesEc.plugins.editingPlugin.feature.actions.edit
      .from('PageConfigurationDialog.Component.SaveBtn.Clicked')
      .dispatch({
        edit: page => {
          if (!page) {
            return
          }
          return {
            ...page,
            ...this.store.editingPageConfigurationSg(),
          }
        },
      })
  }

  /** Discard changes handler */
  public cancelClickHandler(): void {
    // Closing page configuration dialog
    this.store.patchState({ presentPageConfiguration: false })

    const page = this.pagesEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asSignal()

    // Synchronizes the editing configuration signal with the previous page state
    this.store.updateEditingPageConfiguration(page ?? {})
  }
}
